import { render } from "./form.vue?vue&type=template&id=2a5dfbad&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=2a5dfbad&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a5dfbad"

export default script